// extracted by mini-css-extract-plugin
module.exports = {"text":"privacyPage_text__yW2ze"};